import { useSearchParams } from 'react-router-dom';

/** The URL query as the view's state: `get(key)` and `set({key: value | null})` (empty values are dropped). */
export function useUrlParams() {
  const [params, setParams] = useSearchParams();
  const get = (key: string) => params.get(key) ?? '';
  /** A value from `allowed`, else `fallback`. */
  const pick = <T extends string>(key: string, allowed: readonly T[], fallback: T): T =>
    (allowed as readonly string[]).includes(get(key)) ? (get(key) as T) : fallback;
  const set = (patch: Record<string, string | null | undefined>) =>
    setParams(
      (cur) => {
        const next = new URLSearchParams(cur);
        for (const [k, v] of Object.entries(patch))
          if (v == null || v === '') next.delete(k);
          else next.set(k, v);
        return next;
      },
      { replace: true }
    );
  return { get, pick, set };
}

export const when = (iso?: string | null) => (iso ? new Date(iso).toLocaleString() : '');
